import { t } from '@lingui/core/macro'
import type {
  CargoInput,
  PodeAdicionarCargoQuery,
  PodeAdicionarCargoQueryVariables
} from '@/core/types/graphql'
import { PODE_ADICIONAR_CARGO_QUERY } from '../data/cargos'
import { useCallback, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const usePodeAdicionarCargo = () => {
  const queryClient = useQueryClient()
  const [isLoading, setIsLoading] = useState(false)

  const validate = useCallback(
    async (
      cargoAdicionado: CargoInput,
      cargosExistentes: CargoInput[]
    ): Promise<void> => {
      const variables: PodeAdicionarCargoQueryVariables = {
        podeAdicionarCargoInput: {
          cargoAdicionadoInput: cargoAdicionado,
          cargosInputs: cargosExistentes
        }
      }

      setIsLoading(true)
      try {
        const data = await queryClient.fetchQuery({
          queryKey: ['permissoes', variables],
          queryFn: async () =>
            await request<
              PodeAdicionarCargoQuery,
              PodeAdicionarCargoQueryVariables
            >(PODE_ADICIONAR_CARGO_QUERY, { variables })
        })

        if (!data.podeAdicionarCargo) {
          throw Error(
            t`Não foi possível adicionar o cargo. Verifique se a data de início do cargo é posterior à data de início dos cargos já selecionados.`
          )
        }
      } finally {
        setIsLoading(false)
      }
    },
    [queryClient]
  )

  return { validate, isLoading }
}
